<template>
  <lifecycle-stepper
    :steps="stepDefinitions"
    :current-step="step"
  />
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import LifecycleStepper, { StepDefinition } from '../common/LifecycleStepper.vue';

export default defineComponent({
	components: {
    LifecycleStepper,
	},
  props: {
    lifecycleInfo: {
      type: Object as PropType<{
        PickupDateTime: string,
        DeliveryDateTime: string,
        Eta: string,
        AttemptedNotDelivered: boolean
    }>,
      required: true,
    },
    timezone: {
      type: Boolean,
      required: true
    },
    step: {
      type: Number,
      required: true,
    },
  },
  computed: {
    stepDefinitions(): StepDefinition[] {
      return [
        {
          header: 'Out for Delivery',
          subHeader: this.lifecycleInfo.PickupDateTime !== ''
            ? this.lifecycleInfo.PickupDateTime
            : null
        },
        {
          header: 'Estimated Arrival',
          subHeader: this.lifecycleInfo.PickupDateTime && !this.lifecycleInfo.DeliveryDateTime
            ? (this.lifecycleInfo.Eta ?? (this.timezone ? 'No GPS Data' : 'Invalid Zip Code, Unable to Calculate ETA')) 
            : null
        },
        {
          header: this.lifecycleInfo.AttemptedNotDelivered ? 'Attempted' : 'Delivered',
          headerBold: this.lifecycleInfo.AttemptedNotDelivered,
          subHeader: this.lifecycleInfo.DeliveryDateTime || null
        }
      ];
    },
  },
});
</script>

